import React from 'react'

import Header from '../../../components/header'
import DoctorCard from '../../../components/doctor-card'

import * as S from './styles'

import IProps from './props'

const Contracts = ({ contractedDoctors }: IProps) => (
  <S.Container>
    <Header title="Histórico de médicos contratados" />
    <S.Content>
      {contractedDoctors.map((doctor) => (
        <DoctorCard
          key={`contracted-doctor-${doctor.id}`}
          name={doctor.name}
          location={doctor.address.city}
          linkProfile={doctor.linkProfile}
          showIcon={false}
        />
      ))}
    </S.Content>
  </S.Container>
)

export default Contracts
